// config.js
// API Configuration
const DEFAULT_BASE_URL = "https://api.asterickx.com/api";

// Get base URL from localStorage or use default
const getBaseUrl = () => {
  const savedUrl = localStorage.getItem("apiBaseUrl");
  return savedUrl || DEFAULT_BASE_URL;
};

export const API_CONFIG = {
  get BASE_URL() {
    return getBaseUrl();
  },
  ENDPOINTS: {
    MEMBERS: "/Members",
    LOGIN: "/Auth/login"  // Added LOGIN endpoint
  }
};

// Helper function to build full API URLs
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};